<template>
  <v-text-field
    class="copy-text-field tw-pointer-events-auto"
    ref="textField"
    :name="name"
    :label="label"
    :value="value"
    @input="(v) => $emit('input', v)"
    outlined
    readonly
    background-color="#F2F2F2"
  >
    <template v-slot:append>
      <v-btn
        text
        small
        color="primary"
        class="tw-text-base copy-btn"
        @click="onCopy"
      >
        <img class="tw-mr-2" src="/images/icons/copy.svg" />
        {{ copyButtonText }}
      </v-btn>
    </template>
  </v-text-field>
</template>

<script>
export default {
  name: 'CopyTextField',
  props: {
    value: {
      type: String,
    },
    name: {
      type: String,
    },
    label: {
      type: String,
    },
    copyButtonText: {
      type: String,
      default: 'คัดลอก'
    },
  },
  methods: {
    onCopy() {
      let textField = this.$refs.textField.$el.querySelector('input')
      textField.select()
      document.execCommand("copy");
    }
  }
}
</script>

<style lang="scss" scoped>
.copy-btn {
  transform: translateY(-4px);
}

.copy-text-field.v-input label {
  color: #c4c4c4;
}
</style>